import React from 'react'
import CommitDetail from '../oam/components/commit-detail/CommitDetail'

const  CollegeCommitDetail = () => {
  return (
    <div>
        <CommitDetail mode="college-oam"/>
    </div>
  )
}

export default CollegeCommitDetail